import {ExternalLinkHandlerBase} from "./external-link-handler-base";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {IExternalLinkRenderer} from "../renderers/external-link-renderer.interface";
import {
    ExternalLinkIframeRenderer,
    ExternalLinkIframeRendererOptions
} from "../renderers/external-link-iframe.renderer";

export type ExternalLinkInIframeRendererParams = Omit<ExternalLinkIframeRendererOptions, 'onClosed'>;

export abstract class ExternalLinkInIframeHandlerBase extends ExternalLinkHandlerBase {
    constructor(services: IServiceFactoryExtended) {
        super(services);
        this.addSdkEventSubscription(this.services.sdk.events.onPostMessage(this._handlePostMessage));
    }

    protected abstract _onPostMessageReceived(message: MessageEvent): Promise<void>;
    protected abstract _getGnwpSource(): string;

    private _handlePostMessage = async (message: MessageEvent) => {
        if(message.source !== this.renderer.iframeElementRef?.contentWindow) {
            return;
        }

        this._sendAnalytics(message);
        await this._onPostMessageReceived(message);
    }

    protected _sendAnalytics(message: MessageEvent): void {
        const action = `ExternalLink ${this._getGnwpSource()}`;
        if(message.data) {
            this.services.analytics.sendTechnicalEvent(action, `PostMessage: ${JSON.stringify(message.data)}`);
        } else {
            this.services.analytics.sendTechnicalEvent(action);
        }
    }

    private _renderer: IExternalLinkRenderer | null = null;
    get renderer(): IExternalLinkRenderer {
        if(!this._renderer) {
            this._renderer = this._createRenderer();
        }

        return this._renderer;
    }

    protected abstract _getIframeRendererParams(): ExternalLinkInIframeRendererParams;

    protected _createRenderer(): ExternalLinkIframeRenderer {
        return new ExternalLinkIframeRenderer(this.services, {
            ...this._getIframeRendererParams(),
            onClosed: this._onExternalLinkClosed
        });
    }

    protected _onExternalLinkClosed = async () => {
        this.dispose();
    }

    protected _closeExternalLinkDialog = () => {
        this.renderer.dispose();
    }

    protected async _showExternalLinkDialog(url: string): Promise<void>  {
        await this.renderer.render(url)
    }
}